import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { theme } from "../../Common/SetupProfile/constant";

export const DropDown = ({
  options,
  label,
  onChange,
  name,
  error,
  helperText,
  value,
  multiple = false,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <FormControl sx={{ width: "100%" }}>
        <Select
          name={name}
          multiple={multiple}
          size="small"
          sx={{ width: "100%" }}
          displayEmpty
          value={value}
          onChange={onChange}
          error={error}
          renderValue={(value) => {
            if (!value || !value?.length) {
              return <Typography color="#3C3C4399">{label}</Typography>;
            }
            return (
              <>
                {multiple
                  ? options
                      .filter((i) => value.includes(i.value))
                      .map((i) => i.label)
                      .filter(Boolean)
                      .join(", ")
                  : options.find((i) => i.value === value)?.label}
              </>
            );
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 232, // Adjust the maxHeight of the dropdown list
                overflowY: "scroll", // <- changed from 'auto'
                scrollbarWidth: "thin", // Firefox
                "&::-webkit-scrollbar": {
                  width: "8px", // Chrome, Safari
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#ccc",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent",
                },
              },
            },
          }}
        >
          {options.map((i) => (
            <MenuItem value={i.value}>{i.label}</MenuItem>
          ))}
        </Select>
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </FormControl>
    </ThemeProvider>
  );
};
